"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.awardsPropTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AwardsList = require("./AwardsList.style");

var _types = require("./types");

var _Typography = require("../Typography");

var AwardsList = function AwardsList(_ref) {
  var explicit = _ref.explicit,
      awards = _ref.awards;
  var availableAwards = Object.values(_types.AwardTypes);
  var sortedAwards = availableAwards.filter(function (award) {
    return awards.some(function (a) {
      return Object.keys(a)[0] === award;
    });
  });
  var onlyShortlisting = awards.every(function (award) {
    return Object.keys(award)[0] === _types.AwardTypes.Shortlisted;
  });

  var reducer = function reducer(accumulator, award) {
    return Object.values(award)[0] + accumulator;
  };

  var totalAwards = awards.reduce(reducer, 0);
  var awardText = "".concat(totalAwards, " Award").concat(totalAwards > 1 ? 's' : '');
  var shortlistText = "".concat(totalAwards, " Shortlisting");
  return /*#__PURE__*/_react.default.createElement(_AwardsList.AwardsContainer, {
    explicit: explicit
  }, /*#__PURE__*/_react.default.createElement(_AwardsList.Awards, {
    explicit: explicit
  }, sortedAwards.map(function (award, idx) {
    var id = "".concat(idx, "-").concat(award);
    var awardData = awards.find(function (a) {
      return Object.keys(a)[0] === award;
    });
    var label = "".concat(Object.values(awardData)[0], " ").concat(Object.keys(awardData)[0]);
    return /*#__PURE__*/_react.default.createElement(_AwardsList.Award, {
      key: id,
      explicit: explicit
    }, /*#__PURE__*/_react.default.createElement(_AwardsList.Dot, {
      key: id,
      award: award
    }), explicit && /*#__PURE__*/_react.default.createElement(_Typography.Body, {
      size: "xsmall"
    }, label));
  })), /*#__PURE__*/_react.default.createElement(_Typography.Body, {
    size: "xsmall"
  }, onlyShortlisting ? shortlistText : awardText));
};

var awardsPropTypes = _objectSpread({}, Object.keys(_types.AwardTypes).map(function (a) {
  return _propTypes.default.shape(_defineProperty({}, a, _propTypes.default.string));
}));

exports.awardsPropTypes = awardsPropTypes;
AwardsList.propTypes = {
  awards: _propTypes.default.arrayOf(_propTypes.default.shape({
    awardsPropTypes: awardsPropTypes
  })).isRequired,
  explicit: _propTypes.default.bool
};
AwardsList.defaultProps = {
  explicit: false
};
var _default = AwardsList;
exports.default = _default;